<template>
  <div class="settle-wrap">
    <div class="loading-wrap" v-if="!pageLoaded">
      <i class="el-icon-loading"  />
    </div>
    <div v-else>
      <div class="settle-indexs">
        <div class="settle-index index-1" :class="currentIndex > 1 ? 'green-index' : ''">
          
          <div class="index-round">
            <p v-if="currentIndex === 1">1</p>
            <i v-else class="el-icon-check"></i>
          </div>
          <div class="index-text">{{$t('upgrade_page_views_settled_in_index_1151')}}</div>
        </div>
        <div class="settle-line line-1"></div>
        <div class="settle-index index-2" :class="currentIndex === 1 ? 'grey-index' : currentIndex === 2 ? '' : 'green-index'">
          <div class="index-round">
            <p v-if="currentIndex < 3">2</p>
            <i v-else class="el-icon-check"></i>
          </div>
          <div class="index-text">{{$t('upgrade_page_views_settled_in_index_1152')}}</div>
        </div>
        <div class="settle-line line-2"></div>
        <div class="settle-index index-3" :class="currentIndex === 3 ? '' : 'grey-index'">
          <div class="index-round">3</div>
          <div class="index-text">{{$t('upgrade_page_views_settled_in_index_1153')}}</div>
        </div>
      </div>
      <div class="index-wrap">
        <Question
          v-if="currentIndex === 1"
          @toStep="toStep"
        />
        <Settle
          v-if="currentIndex === 2"
          @toStep="toStep"
        />
        <Checking
          v-if="currentIndex === 3"
        />
      </div>
    </div>
   
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'
import Question from './question/index'
import Settle from './step-2'
import Checking from './step-3'
export default {
  components: {
    Question,
    Settle,
    Checking
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      currentIndex: 1,
      pageLoaded: false,
      isCheckingSkill: false,
    }
  },
  beforeRouteLeave(to,from,next) {
    if (this.adminAction || to.name === 'Login') {
      next()
      return
    }
    if(this.currentIndex === 1) {
      this.$confirm({
        title: i18n.t('upgrade_page_views_settled_in_index_1154'),
        confirmButtonText: i18n.t('upgrade_page_views_settled_in_index_1155'),
        cancelButtonText: i18n.t('upgrade_page_views_settled_in_index_1156'),
        closeOnClickModal: false,
      }).then(()=>{
      }).catch(()=>{
        next()
      })
    } else if(this.currentIndex === 2){
      this.$confirm({
        content: i18n.t('upgrade_page_views_settled_in_index_1157'),
        title: i18n.t('upgrade_page_views_settled_in_index_1158'),
        confirmButtonText: i18n.t('upgrade_page_views_settled_in_index_1159'),
        cancelButtonText: i18n.t('upgrade_page_views_settled_in_index_1156'),
        closeOnClickModal: false,
      }).then(()=>{
      }).catch(()=>{
        next()
      })
    } else {
      next()
    } 
  },
  created() {
    this.getSkillStatus()
  },
  methods: {
    toStep(step) {
      this.currentIndex = step
    },
    getSkillStatus() {
      if (this.userInfo.userKind === 'Player') {
        this.adminAction = true
        this.$router.replace({
          name: 'homepage'
        })
        return
      }
      this.$store.dispatch('app/getGamesList').then(({ allGames }) => {
        if (allGames) {
          this.pageLoaded = true
          for (var attr in allGames) {
            for (var i in allGames[attr]) {
              if (allGames[attr][i].status === 'Checking') {
                this.isCheckingSkill = true
                this.currentIndex = 3
                return
              }
            }
          }
          if (window.localStorage.getItem(this.userInfo.uuid + '_RATE') && parseInt(window.localStorage.getItem(this.userInfo.uuid + '_RATE')) > 89) {
            this.currentIndex = 2
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.settle-wrap {
  min-height: 500px;
  border-radius: 8px;
  margin: 50px auto 100px;
  .loading-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    height: 500px;
  }
  .settle-indexs {
    margin-top: 60px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .settle-index {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 27px;
      .index-round {
        width: 24px;
        height: 24px;
        background: #333333;
        border-radius: 100%;
        color: white;
        line-height: 24px;
        text-align: center;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .index-text {
        color: black;
      }
    }
    .settle-line {
      border-top: 1px dashed #999999;
      width: 72px;
      margin-right: 27px;
    }
    .green-index {
      .index-round {
        background: #5AB64E;
      }
    }
    .grey-index {
      .index-round {
        background: none;
        border: 2px solid #636D86;
        box-sizing: border-box;
        line-height: 20px;
        color: #636D86;
      }
      .index-text {
        color: #636D86;
      }
    }
  }
  
}
</style>